import React from 'react'
import PropTypes from 'prop-types'

import { usePageFilters } from '@campaignhub/react-hooks'

import Box from '../Box'
import Button from '../Button'
import FilterComponent from '../FilterComponent'
import FormField from '../FormField'
import SidebarModal from '../SidebarModal'

const PageFilterModal = (props) => {
  const {
    callbacks,
    callbacks: { updateFilters },
    entities,
    filterFields,
    modalKey,
    pageFilters,
    showModal,
    strings,
    supportedComponents,
  } = props

  const filterPayload = usePageFilters(filterFields, { defaultFilters: pageFilters, entities })
  const {
    callbacks: { prepareFilterValues, resetFilters },
  } = filterPayload

  return (
    <SidebarModal callbacks={callbacks} modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title={strings.header?.title || 'Manage'}
        titleSecondLine={strings.header?.titleSecondLine || 'Filters'}
      />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>
          {filterFields.map((filterField) => (
            <FilterComponent
              filterField={filterField}
              filterPayload={filterPayload}
              key={filterField.key}
              supportedComponents={supportedComponents}
            />
          ))}

          <FormField direction="column" label={strings.label}>
            <Button buttonStyle="secondaryUtility" onClick={resetFilters} size="medium">
              {strings.resetFiltersButton || 'Reset Filters'}
            </Button>
          </FormField>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          onClick={() => updateFilters(prepareFilterValues())}
          size="large"
          style={{ width: '100%' }}
        >
          {strings.applyFiltersButton || 'Apply Filters'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

PageFilterModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  entities: PropTypes.object,
  filterFields: PropTypes.array.isRequired,
  modalKey: PropTypes.string,
  pageFilters: PropTypes.object.isRequired,
  showModal: PropTypes.bool,
  supportedComponents: PropTypes.object.isRequired,
}

PageFilterModal.defaultProps = {
  entities: {},
  modalKey: 'PageFilterModal',
  strings: {},
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <PageFilterModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
